import React from 'react';

const Uganda1_kindergarten_phy = () => {
  return (
    <div>
      
    </div>
  );
}

export default Uganda1_kindergarten_phy;
